export const BRAND = {
  logo: "/brand/logo.webp",
  joeAvatar: "/brand/joe-avatar.webp",
  team: "/brand/team.webp",
  flyer: "/brand/flyer.webp",
  flyerFront: "/brand/flyer-front.jpg",
  flyerBack: "/brand/flyer-back.jpg",
  tagline: "Real Answers. Real Options. A Brighter Tomorrow.",
};

export const CREW = {
  joe: { name: "Joe", role: "The Homeowner Guide", img: BRAND.joeAvatar, color: "#1B3264", desc: "Asks the right questions, explains your options, and connects you to the right specialist." },
  claire: { name: "Claire", role: "The Research Cat", img: "/brand/claire.webp", color: "#7B3FBF", desc: "Finds information, explains the process, and helps you understand your options." },
  oliver: { name: "Oliver", role: "The Legal Owl", img: "/brand/oliver.webp", color: "#1F4E8C", desc: "Explains legal terms, deadlines, and when to talk to an attorney." },
  rusty: { name: "Rusty", role: "The Solutions Raccoon", img: "/brand/rusty.webp", color: "#2E8B3A", desc: "Shows creative solutions, compares options, and helps you see the pros and cons." },
  terry: { name: "Terry", role: "The Money Turtle", img: "/brand/terry.webp", color: "#3B9A3F", desc: "Helps with numbers, equity estimates, affordability, and financial planning options." },
  fiona: { name: "Fiona", role: "The Real Estate Fox", img: "/brand/fiona.webp", color: "#D23A1E", desc: "Explains selling options from traditional to as-is and helps you understand the market." },
  buddy: { name: "Buddy", role: "The Support Bunny", img: "/brand/buddy.webp", color: "#1F5FB5", desc: "Keeps you on track and reminds you of next steps so you never feel alone." },
};

export const SECTION_GUIDE = {
  triage: "oliver", problem: "joe", ownership: "claire", goal: "joe", mortgage: "terry", liens: "terry", taxes: "terry",
  foreclosure: "oliver", hardship: "claire", cashflow: "terry", value: "terry", condition: "fiona", selling: "fiona", safety: "oliver",
};

export const Guide = ({ who = "joe", size = 44, label = true, testId }) => {
  const c = CREW[who];
  return (
    <div className="flex items-center gap-2.5" data-testid={testId || `guide-${who}`}>
      <img src={c.img} alt={c.name} style={{ width: size, height: size, borderColor: c.color }} className="shrink-0 rounded-full border-[3px] bg-white object-cover" />
      {label && <div className="leading-tight"><p className="font-display text-base font-bold uppercase" style={{ color: c.color }}>{c.name}</p><p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{c.role}</p></div>}
    </div>
  );
};
